module.exports = __webpack_public_path__ + "img/facts_1929.1c920b83.jpg";